import m from "../../geodata/es2015/maldivesLow";
window.am4geodata_maldivesLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/maldivesLow.js
// module id = null
// module chunks = 